<template>
    <div class="wrapper-right">
        <div class="h-a-item" v-for="(item,index) in items" :key="index"
             @mouseenter="selected = index" @mouseleave="mouseleave($event)"
             :class="{active: index === selected}"
             >
            <div class = "img-div">
                <a href = "javascrip:void(0)" @click="jumpToDetail(item)">
                    <img :src="item.productImgPath">
                </a>
            <!-- <div :id = "item.productId" style="position:fixed;z-index=9999;bottom:150px; width: 100px;height: 100px;">
                <transition name="shop_cart" @before-enter="beforeEnter" @enter="Enter" @after-enter="afterEnter">
                    <img  class="add_img"  v-if="addShow&&selected === index" :src="item.productImgPath" alt="" style="z-index:9999">                    
                </transition>
            </div> -->
            </div>
            
            <div class="price-tags">
                <p class="price">￥{{item.shopPrice}}</p>
                <div class="tags">
                    <span class="tag" v-for="(tag,tIndex) in item.tags" :key="tIndex">{{tag}}</span>
                </div>
            </div>

            <div class="text-div">
                <a  href = "javascrip:void(0)" @click="jumpToDetail(item)" style="text-decoration: none;color:black">
                    <p>
                        {{item.productName}}
                    </p>
                </a>
            </div>

            <div class="supplier-div">
                <p>
                    {{item.supplier}}
                </p>
            </div>
			<transition-group name="slide" class="slide" tag="div">
                <div class="commit" v-if="selected === index" :key="index" @click="addToCart(item,index)" style="cursor: pointer">
                    <a href="javascript:void(0)">
                        <p style="font-family: PingFangSC-Regular;font-size: 14px;color: #FFFFFF;letter-spacing: 0;text-align: left;" >{{constant.addToCart}}</p>
                    </a>
                </div>
            </transition-group>            
        </div>
    </div>

</template>

<script>
    export default {
        components: {

        },
        props:["items"],
        data() {
            return {
                isMouseEnter: false,
                selected: -1,
                addShow: false,
                constant:this.$store.state.malMainPageConfig.constant
            }
        },
        methods:{
            addToCart(item,index){
                //  this.addShow = true;
                this.$api.mainpageApi.addToCart(item.productId,item.source).then(response=>{
                    if(response.data.success){
                        this.$store.commit({
                            type:'updateCartNum',
                            currentNum:response.data.data
                        })
                        this.$message({
                            showClose: true,
                            message: item.productName+this.$store.state.malMainPageConfig.constant.addToCartSuccess,
                            type: 'success'
                            })
                    }else{
                        this.$message({
                        showClose: true,
                        message: item.productName+this.$store.state.malMainPageConfig.constant.addToCartFail,
                        type: 'error'
                        })
                    }
                    }).catch(error=>{
                        this.$message({
                        showClose: true,
                        message: item.productName+this.$store.state.malMainPageConfig.constant.addToCartFail,
                        type: 'error'
                        })
                    });
            },
            jumpToDetail(product){
                let param = "";
                if(product.source==="1"){
                    param = "&productSelfId="+product.productId;
                }else if(product.source==="2"){
                    param = "&productJdSku="+product.productId;
                }
                param = param + "&opentype=NewWindow";
                const base = window.location.href.split("/isv/")[0];
                let url = base+"/index.html#/dform?&formId=mal_productdetail"+param;
                window.open(url,"_blank");
            },
            mouseleave(event){
                if(event.relatedTarget!=null){
                    this.selected = -1
                }
            }
 

            // beforeEnter:function(el){
			// 			el.style.transform="translate(40px,20px)";
			// 		},
            // Enter:function(el,done){
            //     el.offsetWidth;//必要！？？？、、、
            //     el.style.transition="all 2s ease-out";
            //     el.style.transform="translate(400px,-400px)";
            //     el.style.zIndex = "9999";	
                
            //     done();//done函数表示afterEnter函数，即立即引用下面函数，没有延迟
            // },
            // afterEnter:function(el){
            //          this.addShow = false;
            // }
        }
    }

</script>

<style scoped lang="scss">
    .wrapper-right {
        width: 1100px;
        height: 429px;
        color: #333;
        display: flex;
        flex-flow: wrap;
        justify-content: flex-start;
        align-content: space-between;
    }
    .wrapper-right .active {
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
        margin-top: -1px;
        transition: all .2s linear;
    }


    .h-a-item {
        position: relative;
        z-index:1;
        overflow: hidden;
        height: 380px;
        width: 250px;
        margin-left: 25px;
        background: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        text-align: center;
    }
    .h-a-item .img-div a img{
        width: 250px;
        height: 250px;
     }

    .price-tags{
        width: 210px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px 0px 10px 0px;
    }

    .h-a-item .price{
        font-family: PingFangSC-Regular;
        font-size: 18px;
        width: 100px;
        color: #FC8555;
        letter-spacing: 0;
        text-align: left;
        line-height: 20px;
        margin: 0px;
    }
    .h-a-item .tags{
        display: flex;
        justify-content: flex-end;
        font-size: 12px;
        font-weight: 400;
        height: 20px;
        margin: 0px;
        font-family: PingFangSC-Regular;
        color: #FFFFFF;
        letter-spacing: 0;
        overflow: hidden;
    }
    .h-a-item .tags .tag{
        background: #FC8555;
        border: 1px solid #FC8555;
        border-radius: 9px;
        padding: 0 3px 0 3px;
        margin: 0 0 0 5px;
        height: 16px;
        /*width : 32px;*/
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #FFFFFF;
        letter-spacing: 0;

        text-align: center;

    }

    .img-div{
        width:250px;
        height: 250px;
    }
    .text-div{
        width: 250px;
        font-size: 12px;
        height: 36px;
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
    }
    .text-div p{
        width: 210px;
        text-align: left;
        height: 36px;
        overflow: hidden;
        line-height: 18px;
        margin: 0px;
    }

    .h-a-item .slide{
        position: absolute;
        opacity: 0.91;
        bottom: 0px;
        left: 0px;
    }

    .h-a-item .commit {
        position: absolute;
        z-index: 2;
        left: 0;
        height: 40px;
        width: 250px;
        opacity: 0.8;
        background: #FC8555;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: translateY(-170px);
    }
    .h-a-item .commit a{
        text-decoration: none;
    }



    .supplier-div p{
        width: 210px;
        text-align: left;
        overflow: hidden;
        margin: 0px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        height: 18px;
        line-height: 18px;
    }

    .slide-enter-active,.slide-leave-active{
        transition: all .2s linear;

        opacity: 1;
        bottom: -40px;
      }
    .slide-enter,.slide-leave-to{
        opacity: 0;
        transition: all .2s linear;
        bottom: 0px;
    }

    .add_img{
        width: 100px;
        height: 100px;
        z-index: 9999;
        // transform: translate(200px, -250px);
    }

    /*加入购物车动画css*/
    // .shop_cart-enter-active {
    //     transition: all 10s ease-out;
    // }
    // .shop_cart-enter {
    //     opacity: .5;
    //     transform: scale(.8);
    // }
</style>
